export const cableUrl = (): string =>
  document.querySelector(`meta[name="action-cable-url"]`)!.getAttribute('content')!
